<rv-badge class="tw-capitalize" [color]="badgeColor" [text]="statusText" />
